import { makeStyles, createStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

type StopSummaryProps = {
  compact?: boolean
  /**
   * is the last stop element
   */
  last?: boolean
}

export const setMobileCompact = (value: any) => ({ compact }: StopSummaryProps = {}) =>
  compact ? undefined : value

export const useStopSummaryStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'block',
      padding: theme.spacing(2),
      marginTop: 0,
      marginRight: 0,
      marginLeft: 0,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        marginRight: setMobileCompact(0),
        marginLeft: setMobileCompact(0),
        marginTop: setMobileCompact(theme.spacing(2)),
        marginBottom: setMobileCompact(theme.spacing()),
        display: setMobileCompact('flex'),
        overflowY: 'scroll',
        maxHeight: '65vh',
      },
    },
    icon: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: setMobileCompact('flex'),
        alignItems: setMobileCompact('center'),
        marginTop: setMobileCompact(0),
        marginBottom: setMobileCompact(0),
        marginRight: setMobileCompact(theme.spacing(2)),
        marginLeft: setMobileCompact(theme.spacing(2)),
      },
    },
  })
)

export const useStopSummaryConnector = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1rem',
      color: brandColors.coolGray5,
      lineHeight: 1,

      [theme.breakpoints.up('md')]: {
        display: setMobileCompact('none'),
      },
    },
    multiStop: {
      marginTop: 0,
      marginRight: 0,
      marginLeft: 0,
      marginBottom: theme.spacing(2),
    },
  })
)

export const useStopsSummaryConnectorIcon = makeStyles(theme =>
  createStyles({
    root: {
      position: 'relative',
      display: 'flex',
      width: '24px',
      flex: '0 0 24px',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: theme.spacing(2),
      zIndex: 1,
      color: brandColors.coolGray4,
      height: 0,
      marginTop: theme.spacing(-2),

      '& svg': {
        opacity: 0,
      },

      '&::before': {
        position: 'absolute',
        display: 'block',
        content: '" "',
        width: '2px',
        top: '-12px',
        bottom: '-12px',
        left: 0,
        right: 0,
        margin: '0 auto',
        zIndex: -1,
        background: brandColors.coolGray4,
      },
    },
    multiStop: {
      height: 'auto',
      marginTop: 0,

      '& svg': {
        opacity: 1,
      },

      '&:before': {
        top: '-20px',
        bottom: '-20px',
      },
    },
  })
)
export const useStopSummaryItem = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    marginTop: 0,
    marginRight: 0,
    marginBottom: theme.spacing(2),
    marginLeft: 0,
    zIndex: 2,

    [theme.breakpoints.up('md')]: {
      margin: setMobileCompact(0),
    },

    '&:last-child': {
      margin: 0,
    },
  },
  symbol: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    marginBottom: 0,

    [theme.breakpoints.up('md')]: {
      display: setMobileCompact('none'),
    },
  },
}))

export const useStopConfirmationItem = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    marginTop: 0,
    marginRight: 0,
    marginBottom: theme.spacing(4),
    marginLeft: 0,
    zIndex: 2,

    [theme.breakpoints.up('md')]: {
      margin: setMobileCompact(0),
    },

    '&:last-child': {
      margin: 0,
    },
  },
  symbol: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 0,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    marginBottom: 0,
    position: 'relative',
    '&::before': {
      position: 'absolute',
      display: 'block',
      content: ({ last }: StopSummaryProps) => (last ? '' : '" "'),
      width: '2px',
      top: 0,
      bottom: `-${theme.spacing(4)}`,
      left: 0,
      right: 0,
      margin: '0 auto',
      zIndex: -1,
      background: brandColors.coolGray4,
    },

    [theme.breakpoints.up('md')]: {
      display: setMobileCompact('none'),
    },
  },
}))
